import Reveal from "../components/Reveal";

const QUESTIONS = [
  "What do you do?",
  "Is this for me?",
  "Why should I trust you?",
  "Why should I choose you?",
  "What should I do next?",
];

export default function ClarityProblem() {
  return (
    <section data-testid="clarity-problem-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal>
          <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
            Most businesses don't have a website problem.
          </h2>
          <p className="text-gold-gradient mt-4 font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            They have a clarity problem.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-10 text-base leading-relaxed text-slate-400">
            Your customers are trying to answer a few simple questions:
          </p>
          <ul className="mx-auto mt-7 max-w-xl space-y-4 text-left">
            {QUESTIONS.map((q, i) => (
              <li key={q} className="flex items-baseline gap-4">
                <span className="font-mono text-xs font-semibold text-gold">0{i + 1}</span>
                <span className="font-display text-lg font-medium text-slate-200 sm:text-xl">{q}</span>
              </li>
            ))}
          </ul>
          <p className="mx-auto mt-10 max-w-2xl text-lg leading-relaxed text-slate-300">
            A beautiful website that cannot answer those questions is still a bad website.
          </p>
          <div className="gold-hairline mx-auto mt-10 h-px w-48" aria-hidden="true" />
          <p className="mt-10 font-display text-xl font-semibold leading-relaxed text-white sm:text-2xl">
            That's why AT Digital starts with the business before we start with the website.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
